import PropTypes from 'prop-types';
import React from 'react';
import en from '../../../international/translations/en';
import spinner from '../../../../static/btn-spinner.svg';

const SwitchPlans = ({
  dollars,
  cents,
  acceptOffer,
  clickedNoThanks,
  changingPlans,
  changePlansError,
}) => {
  const text = en.cancellation_funnel;
  return (
    <div>
      <h4 className="switch-plans__title">{text.switch_plans_title}</h4>
      <div className="switch-plans__description">
        {text.switch_plans_description}
      </div>
      <div className="switch-plans__plan-container">
        <div className="switch-plans__plan-container__plan">
          <div className="switch-plans__plan-container__plan__name">
            {text.switch_plans_available_plan_text}
          </div>
          <div className="switch-plans__plan-container__plan__price">
            <div className="switch-plans__plan-container__plan__price__currency">
              {en.payment_form.plan_currency_usd}
            </div>
            <div className="switch-plans__plan-container__plan__price__dollars">
              {dollars}
            </div>
            <div className="switch-plans__plan-container__plan__price__small">
              <div className="switch-plans__plan-container__plan__price__cents">
                {cents}
              </div>
              <div className="switch-plans__plan-container__plan__price__interval">
                /mo
              </div>
            </div>
          </div>
        </div>
        <div className="switch-plans__plan-container__credit-text">
          {text.switch_plans_credit_text}
        </div>
      </div>
      {changePlansError ? <div className="switch-plans_error__alert">{changePlansError.message}</div> : null}
      <div>
        <button onClick={acceptOffer} className="cancel__button--keep-premium">
          {changingPlans ? (
            <img
              src={spinner}
              className="cancel__button__submit--submitting__img"
            />
          ) : (
            text.switch_plans_button
          )}
        </button>
        <button
          onClick={clickedNoThanks}
          className="cancel__ghost-button"
        >
          {text.switch_plans_action_skip}
        </button>
      </div>
    </div>
  );
};

SwitchPlans.propTypes = {
  dollars: PropTypes.number.isRequired,
  cents: PropTypes.number.isRequired,
  acceptOffer: PropTypes.func.isRequired,
  clickedNoThanks: PropTypes.func.isRequired,
  changingPlans: PropTypes.bool,
  changePlansError: PropTypes.object
};

SwitchPlans.defaultProps = {
  changingPlans: false,
};

export default SwitchPlans;
